<!-- Task row container - clickable with navigation to task details -->
<div
  class="clickable flex w-full text-[14px] leading-[24px] cursor-pointer"
  [class.bg-[#EBF5FF]]="isSelected()"
  [class.bg-white]="!isSelected()"
  [class.hover:bg-gray-50]="!isSelected()"
  [nxNewTabNavigation]="['./tasks/task', task()?.id]"
  [queryParams]="{ type: 'task', show: task()?.id }">

  <!-- Left section: Color indicator bar -->
  <div class="flex items-start">
    <div class="w-[5px] h-full" [style.background-color]="taskColor()"></div>
  </div>

  <!-- Main content -->
  <div class="flex-1 flex flex-col px-2 py-1 mr-3">

    <!-- Row 1: Title and Status -->
    <div class="grid grid-cols-[1fr_auto] leading-[1.325rem]">
      <!-- Left: Title with icon and due date -->
      <div class="min-w-0">
        <div class="mr-1 float-left w-[18px] h-[18px] mt-[1px]">
          <app-task-type-icon [task]="task()" />
        </div>
        @if (dueDateTime(); as dueDT) {
          <span class="mr-1" [pTooltip]="dueDT?.tooltip">
            <span class="bg-[#EBEEEF] text-black whitespace-nowrap px-2 py-[2px] rounded-md text-[14px] left-0 top-[-2px]">
              {{ dueDT?.text }}
            </span>
          </span>
        }
        {{ taskTitle() }}
      </div>

      <!-- Right: Assignee, files, comments, status -->
      <div class="flex items-center justify-end whitespace-nowrap">
        <app-note-icon [note]="task()?.getNote()" class="mr-1" />
        <app-files-icon class="mr-1" [count]="task()?.fileCount" />
        <app-comments-icon class="mr-1" [count]="task()?.noteCount" />
        @if (task()?.location) {
          <span class="text-[#848488] truncate" [class.mr-2]="!assignmentData()">{{task()?.location?.name}}</span>
        }
        @if (task()?.location && assignmentData()) {
          <span class="text-[#848488]">&nbsp;·&nbsp;</span>
        }
        @if (assignmentData()) {
          <div class="mr-2 text-[#848488] truncate">
            <nx-assignment-display [assignee]="assignmentData()" />
          </div>
        }
        <p-tag [value]="stateLabel()" [severity]="stateSeverity()" class="stateLabel" />
      </div>
    </div>

    <!-- Row 2: Additional info -->
    @if (showAdditionalInfoRow()) {
    <div class="leading-[1.325rem]">
      <span class="text-[#848488]">
        @if (!showMetadataRow()) {
          <span class="font-medium">#{{ task()?.number }}</span>
          @if (visibleFields().length > 0) {
            <span> · </span>
          }
        }
        @for (fieldName of visibleFields(); track fieldName; let isLast = $last) {
          <ng-container [ngTemplateOutlet]="getFieldTemplate(fieldName)" [ngTemplateOutletContext]="{ task: task() }"></ng-container>
          @if (!isLast) {
            <span> · </span>
          }
        }
      </span>
    </div>
    }

    <!-- Row 3: Metadata - Creator and Last Modified -->
    @if(showMetadataRow()) {
    <div class="flex justify-between leading-[1.325rem] text-[#848488]">
      <!-- Left: Task number, creator, creation date -->
      <div>
        #{{ task()?.number }} · Erstellt von <app-user-name [user]="task()?.createdBy" />&nbsp;<app-relative-time [timestamp]="task()?.createdDateTime" />
      </div>

      <!-- Right: Last modified timestamp -->
      <div class="text-right whitespace-nowrap">
        @if (isCompleted()) {
          erledigt <app-relative-time [timestamp]="task()?.completedDateTime" />
        } @else {
          zuletzte bearbeitet <app-relative-time [timestamp]="task()?.lastModifiedDateTime" />
        }
      </div>
    </div>
    }

    <!-- Row 4: Labels -->
    @if (showLabelsRow()) {
    <div class="leading-[1.325rem]">
      @for (label of task()?.labels; track label) {
        <app-label [label]="label" class="mr-1 mb-1"></app-label>
      }
    </div>
    }

  </div>
</div>

<!-- Field Templates -->
<ng-template #orderTpl let-task="task">
  <a [routerLink]="['/orders/order/' + order()?.id]" class="jump" (click)="$event.stopPropagation()">
    <span class="hover:underline cursor-pointer">{{order()?.number}}</span>
  </a>
</ng-template>

<ng-template #customerTpl let-task="task">
  <a [routerLink]="['/customers/customer/' + customer().id]" class="jump" (click)="$event.stopPropagation()">
    <span class="hover:underline cursor-pointer">{{customer()?.text}}</span>
  </a>
</ng-template>

<ng-template #addressTpl let-task="task">
  @if (address()?.getAddressString()) {
    {{ address()?.getAddressString() }}
  } @else {
    <span class="italic mr-2">Adresse unvollständig</span>
  }
  <app-address-indicator-v2 [size]="'small'" [grade]="address()?.geocodingResultGrade"></app-address-indicator-v2>
  <app-note-icon [note]="addressTooltip()" [floatLeft]="false" class="inline-flex ml-1" />
</ng-template>

<ng-template #postalCodeTpl let-task="task">
  {{ address()?.postalCode}}
</ng-template>

<ng-template #cityTpl let-task="task">
  {{ address()?.city}}
</ng-template>

<ng-template #resourcesTpl let-task="task">
  @if (resources() && resources()!.length > 0) {
    @for (resource of resources(); track resource.id; let isLast = $last) {
      <a [routerLink]="['/resources/resource/' + resource.id]" class="jump" (click)="$event.stopPropagation()">
        <span class="hover:underline cursor-pointer">{{ resource.text }}</span>
      </a>@if (!isLast) {, }
    }
  }
</ng-template>